module.exports = __webpack_public_path__ + "img/friend-1.a4c395d9.png";